import GlamImage1 from "../../../Assets/img/thumbnail.jpg"
import GlamImage2 from "../../../Assets/img/prop2.jpg"
import GlamImage3 from "../../../Assets/img/prop3.jpg"
import GlamImage4 from "../../../Assets/img/prop4.jpg"

const GlamImagesData = [
    {
      imgSrc: GlamImage1,
    },
    {
      imgSrc: GlamImage2,
    },
    {
      imgSrc: GlamImage3,
    },
    {
      imgSrc: GlamImage4,
    },
  ];
export default GlamImagesData;